import services from './services.js';
import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from "utils";
import {
  GetERP_SendGoodsByPage,
  ERP_AuditSendGoods,
  GetSendGoodsAuditStatistics
} from "@api/sendGoodsApi";
import {
  GetOrderFinanceAuditByPage,
  ERP_AuditOrder,
  GetERP_OrderById
} from "@api/orderApi";
import NProgress from "nprogress";
import {
  MAP_LIST
} from "$http";
import $http from "$http";

import financialAuditView from "./components/financialAuditView/index.vue";

export default {
  mixins: [services],
  components: {
    financialAuditView
  },
  data: function () {
    return {
      auditBtnShow: true,
      ssProjectList: [{
          id: 1,
          name: "联帮在线"
        },
        {
          id: 2,
          name: "HI幼教"
        },
        {
          id: 4,
          name: "智趣坞"
        },
        {
          id: 128,
          name: "联帮会销"
        }
      ],
      packageList: [],
      AuditNum: [],
      Session: util.getSessin(),
      queryType: [{
          TypeName: "-请选择-",
          TypeValue: "-1"
        },
        {
          TypeName: "待审核",
          TypeValue: "1"
        },
        {
          TypeName: "财务审核通过",
          TypeValue: "6"
        }
      ],
      orderStateList: this.$store.state.orderStateMapList,
      loading2: false,
      lists: [{
        Id: "346567788"
      }],
      pageIndex: 1,
      pageSize: 10,
      totalSize: "",
      sels: [], //列表选中列
      SaleCheckView: false,
      pageSizes: [10, 20, 50],
      policyTypeName: "",
      query: this.getQuery()
    };
  },
  methods: {
    getQuery() {
      return cloneDeep({
        OrderCode: "",
        c_name: "",
        SendCode: "",
        AgentName: "",
        ProjectType: "",
        auditStartDate: "",
        auditEndDate: "",
        OrderStatus: "",
        AreaName: "",
        UserName: "",
        SendStatus: "",
        PackageId: ''
      });
    },
    //新增销售下单
    addOrder: function () {
      this.$router.push("/Order/SaleOrder/addOrder");
    },
    reLoadData() {
      this.pageIndex = 1;
      this.List();
    },

    //通用输入参数
    getParams() {
      var para = {
        Sid: this.Session[0],
        Session: this.Session[1],
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        orderBy: this.orderBy
      };
      for (let item in this.query) {
        let value = this.query[item];
        if (value !== "") {
          // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
          if (typeof value == 'string') {
            value = util.trimAllSpace(value);
          }
          this.query[item] = value
          para[item] = value;
          if (item == "auditStartDate" || item == "auditEndDate") {
            para[item] = util.time2str(value);
          }
        }
      }

      return para;
    },
    selsChange: function (sels) {
      this.sels = sels;
    },

    //查询
    onQuerySubmit: function () {
      this.pageIndex = 1;
      this.List();
    },
    //查询功能
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.List();
    },
    //编辑功能
    onQueryClean: function () {
      this.query = this.getQuery();
      this.List();
    },
    //审核
    adoptHandle: function (index, row) {
      this.$refs.refFinancialAuditView.show({
        id: row.OrderId
      });
    },
    //查看
    handleView: function (index, row) {
      util.redirect(
        this,
        "/Order/financialList/ViewOrder?Id=" + row.OrderId,
        true
      );
    },
    //下载文件
    download: function () {
      this.$confirm("确认导出吗？", "提示", {}).then(() => {
        this.List();
        var para = this.getParams();
        //GET /api/Order/GetOrderFinanceAuditExport
        util.exportToFileV2("api/Order/GetOrderFinanceAuditExport", para, this);
      });
    },
    handleCurrentChange: function (val) {
      this.pageIndex = val;
      this.List();
    },
    showOrHideAuditBtn() {
      if (this.$route.path == "/Order/financialListReadyOnly" || this.$route.path == "/SchoolOrder/SchoolOrderView") {
        // 订单查看（Hi-E）和查无审核（查看）页面
        this.auditBtnShow = false;
      } else {
        this.auditBtnShow = true;
      }
    }
  },
  watch: {
    $route(to, from) {
      this.query = this.getQuery()
      this.List();
      this.showOrHideAuditBtn();
    }
  },
  created: function () {

    this.List();
    let _session = util.getSessin();
    let para = {
      Sid: _session[0],
      Session: _session[1]
    };

    this.showOrHideAuditBtn();
    this.GetParmConfig(); //获取套餐列表
  }
};


// WEBPACK FOOTER //
// ./src/pages/Order/financialList/vm.js